import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { ApiObject, Program, School } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import { useMediaQuery } from 'react-responsive';
import { AttributeComponent } from './Overview';
import { entityIsProgram, entityIsSchool } from 'common/utils';

interface CompProps {
  entity?: ApiObject<School> | ApiObject<Program>;
  visaRef: React.RefObject<HTMLDivElement>;
}

export const VisaSection = ({ entity, visaRef }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className={styles.sectionContainer} id="visa" ref={visaRef}>
      <div className={styles.sectionTitle}>
        <div className={styles.blueBlock} />
        <h2 className={styles.titleText}>Visa</h2>
      </div>
      {!!(
        entityIsSchool(entity?.data) &&
        ((entity?.data.city.country.working_visa_number &&
          entity?.data.city.country.working_visa_format) ||
          entity?.data.city.country.working_visa_after_study)
      ) && (
        <>
          <div className="d-flex flex-row gap-4">
            {entity?.data.city.country.working_visa_number &&
              entity?.data.city.country.working_visa_format && (
                <AttributeComponent
                  attribute="Working visa during study"
                  value={`${entity.data.city.country.working_visa_number}${entity.data.city.country.working_visa_format}`}
                />
              )}
            {entity?.data.city.country.working_visa_after_study && (
              <AttributeComponent
                attribute="Working visa after study"
                value={`${entity.data.city.country.working_visa_after_study} years`}
              />
            )}
          </div>
        </>
      )}
      {!!(
        entityIsProgram(entity?.data) &&
        ((entity?.data.school.city.country.working_visa_number &&
          entity?.data.school.city.country.working_visa_format) ||
          entity?.data.school.city.country.working_visa_after_study)
      ) && (
        <>
          <div className="d-flex flex-row gap-4">
            {entity?.data.school.city.country.working_visa_number &&
              entity?.data.school.city.country.working_visa_format && (
                <AttributeComponent
                  attribute="Working visa during study"
                  value={`${entity.data.school.city.country.working_visa_number}${entity.data.school.city.country.working_visa_format}`}
                />
              )}
            {entity?.data.school.city.country.working_visa_after_study && (
              <AttributeComponent
                attribute="Working visa after study"
                value={`${entity.data.school.city.country.working_visa_after_study} years`}
              />
            )}
          </div>
        </>
      )}
      {entityIsSchool(entity?.data) && entity?.data.city.country.visa_description && (
        <Text
          size={isMobile ? 14 : 16}
          weight={400}
          inlineStyle={{
            color: '#19234F',
            marginBottom: isMobile ? '0px' : '32px',
          }}
        >
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {entity?.data.city.country.visa_description}
          </ReactMarkdown>
        </Text>
      )}
      {entityIsProgram(entity?.data) && entity?.data.school.city.country.visa_description && (
        <Text
          size={isMobile ? 14 : 16}
          weight={400}
          inlineStyle={{
            color: '#19234F',
            marginBottom: isMobile ? '0px' : '32px',
          }}
        >
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {entity?.data.school.city.country.visa_description}
          </ReactMarkdown>
        </Text>
      )}
    </div>
  );
};
